import { useCallback, useEffect, useState } from "react";
import { useOrgAdminClient } from "./useOrgAdminClient.js";
import { OrgAdminApiError } from "../api/org-admin-client.js";
export function useRuntimeConfig() {
    const client = useOrgAdminClient();
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await client.getRuntimeConfig();
            setConfig(res.data);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : "Failed to load runtime config");
        }
        finally {
            setLoading(false);
        }
    }, [client]);
    useEffect(() => { load(); }, [load]);
    const save = useCallback(async (patch) => {
        try {
            const res = await client.updateRuntimeConfig(patch);
            setConfig(res.data);
            return { ok: true };
        }
        catch (err) {
            // Save errors are surfaced via the discriminated-union return so
            // the caller can render them inline (e.g. as a toast). We do NOT
            // mutate `error` here — that field tracks LOAD failures only, so
            // the page's early-return Retry path stays decoupled from save UX.
            if (err instanceof OrgAdminApiError) {
                return {
                    ok: false,
                    error: err.message,
                    code: err.code,
                    status: err.status,
                    details: err.details,
                };
            }
            const msg = err instanceof Error ? err.message : "Failed to save runtime config";
            return { ok: false, error: msg };
        }
    }, [client]);
    return { config, loading, error, save, reload: load };
}
//# sourceMappingURL=useRuntimeConfig.js.map